import React from 'react';
import classNames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import RTE from 'shared/components/rte/rte.jsx';

export default React.createClass({
  mixins: [PureRenderMixin],

  render() {
    let { rowIndex } = this.props;

    return (
      <div
        key={rowIndex + '-note-drft'}
        className={classNames('csr-note-cell')}
      >
        <RTE
          ref="rte"
          displayToolbar={false}
          readOnly={true}
          rteState={this._getCellState()}
        />
      </div>
    );
  },

  _getUserSettings() {
    let { item } = this.props;
    return item.get('userSettings');
  },

  _getCellState() {
    let { userId } = this.props;

    let userSettings = this._getUserSettings();

    let path = [userId, 'note', 'rteState'];

    if (userSettings && userSettings.hasIn(path)) {
      return userSettings.getIn(path);
    }

    return null;
  },
});
